import { Trans } from '@lingui/macro';
import { ReactComponent as TriangleLeft } from 'assets/icons/triangle_left.svg';
import React from 'react';
import { useAppDispatch } from 'state/hooks';
import { updateScreenCursorState } from 'state/phonebooth/slice';
import styled from 'styled-components/macro';

import TextShadow from '../animations/TextShadow';

type BackButtonProps = {
  sizeRatio?: number;
  onBack: () => void;
  className?: string;
};

const Wrapper = styled.button<{ sizeRatio?: number }>`
  display: flex;
  align-items: center;
  background: none;
  outline: none;
  border: none;
  padding: 0;
  margin: 0;
  font-weight: bold;
  font-size: ${({ sizeRatio }) => `${(sizeRatio ?? 1) * 16}px`};
  animation: ${TextShadow} 1.6s infinite;

  color: ${({ theme }) => theme.text1};

  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 14px;
  `};
`;

interface SvgStyledProps {
  className?: string;
  sizeRatio?: number;
}

const BackIcon = styled(({ sizeRatio, ...props }) => <TriangleLeft {...props} />)<SvgStyledProps>`
  height: ${({ sizeRatio }) => `${(sizeRatio ?? 1) * 13}px`};

  ${({ theme }) => theme.mediaWidth.upToMedium`
    height: 13px;
  `};
`;

const BackButton: React.FC<BackButtonProps> = ({ sizeRatio, onBack, className }) => {
  const dispatch = useAppDispatch();
  return (
    <Wrapper
      sizeRatio={sizeRatio}
      className={className}
      type="button"
      onClick={onBack}
      onMouseEnter={() => dispatch(updateScreenCursorState('pointer'))}
      onMouseLeave={() => dispatch(updateScreenCursorState('hover'))}
    >
      <BackIcon sizeRatio={sizeRatio} />
      <Trans>BACK</Trans>
    </Wrapper>
  );
};

export default BackButton;
